<template>
  <div>
    <v-container style="max-width: 800px">
      <v-layout>
        <v-container class="table-full">
          <v-layout row wrap>
            <v-flex
              class="expandableContainer ma-0 pa-0"
              style="overflow: hidden"
            >
              <v-data-table
                select-all
                :headers="headers"
                :items="items"
                hide-actions
                ref="table"
                item-key="id"
                no-data-text="No tiene invitaciones"
                :height="'14vh'"
                style="max-height: 18vh; overflow-y: scroll"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td>
                    <CustomTooltipOverflowText>
                      {{ props.item.firstName }}
                    </CustomTooltipOverflowText>
                  </td>
                  <td>
                    <CustomTooltipOverflowText>
                      {{ props.item.lastName }}
                    </CustomTooltipOverflowText>
                  </td>
                  <td>
                    <CustomTooltipOverflowText>
                      {{ props.item.level.typeLevel }}
                    </CustomTooltipOverflowText>
                  </td>
                  <td>
                    <CustomTooltipOverflowText>
                      <div>
                        <span>{{ props.item.gradeGroup.grade }}</span>
                        <span>{{ props.item.gradeGroup.group }}</span>
                      </div>
                    </CustomTooltipOverflowText>
                  </td>
                  <td>
                    {{ props.item.personId }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
  </div>
</template>

<script>
import CustomTooltipOverflowText from '../../../generic/custom_tooltip_overflow_text.vue'

export default {
  props: ['items'],
  components: {
    CustomTooltipOverflowText,
  },
  data() {
    return {
      headers: [
        {
          text: 'Nombre',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Apellido',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Nivel',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Grupo/Grado',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Matrícula',
          sortable: false,
          align: 'center',
        },
      ],
    }
  },
}
</script>

<style scoped>
::v-deep .table-full .v-datatable.v-table > tbody {
  /* max-height: initial !important; */
  min-height: initial !important;
}
</style>
